export default {
    activix: 'Activix',
    autopropulsion: 'Autopropulsion',
    quicktrade: 'Torque',
    cdkCustomer: 'CDK - Customer',
    cdkRvService: 'CDK - Service',
    ctwizard: 'CTWizard',
    dealerVu: 'DealerVu',
    deskit: 'Deskit',
    easydeal: 'Easy Deal',
    fcaDigital: 'Fiat Chrysler Canada',
    forddirect: 'Ford Canada',
    gmcanada: 'GM Canada',
    lucy: 'Lucy',
    mbcaDigital: 'Mercedes Canada',
    nciDigital: 'Nissan-Infiniti Canada',
    oneEighty: 'One-Eighty',
    polestar: 'Polestar',
    porscheDigital: 'Porsche Canada',
    kiaDigital: 'Kia Canada',
    sciMarketviewSale: 'Taq Auto - Sale',
    sciMarketviewService: 'Taq Auto - Service',
    scraper: 'Scraper',
    sertiRvService: 'Serti - Service',
    sertiVente: 'Serti - Sale',
    vauto: 'vAuto',
    polarisDigital: 'Polaris',
    pbs_work_order: 'PBS - Work Oder',
    pbs_service: 'PBS - Service',
    pbsService: 'PBS - Service',
    merlin: 'Merlin',
    maserati_digital: 'Maserati Digital',
    one_eighty_inventory: 'One-Eighty - Inventory',
    cdk_inventory: 'CDK - Inventory',
    serti_inventory: 'Serti - Inventory',
    pbs_inventory: 'PBS - Inventory',
    easydeal_inventory: 'EasyDeal - Inventory',
    serti_renewal: 'Serti - Renewal',
    bmwCanada: 'BMW Canada',
    fni_prestige: 'FNI Prestige',
    stellantisDigital: 'Stellantis Digital',
    ringcentral: 'RingCentral',
    vbdc: 'VBDC',

    All: 'All',
    sci_marketview_sale: 'Taq Auto - Sale',
    sci_marketview_service: 'Taq Auto - Service',
    easy_deal: 'Easy Deal',
    dealer_vu: 'DealerVu',
    mbca_digital: 'Mercedes Canada',
    fca_digital: 'Fiat Chrysler Canada',
    porsche_digital: 'Porsche Canada',
    polaris_digital: 'Polaris Canada',
    kia_digital: 'Kia Canada',
    harleyDavidsonDigital: 'Harley Davidson Canada',
    harley_davidson_digital: 'Harley Davidson Canada',
    nci_digital: 'Nissan-Infiniti Canada',
    nissan_digital: 'Nissan-Infiniti Canada',
    cdk_service_appt: 'CDK - Service',
    cdk_rv_service: 'CDK - Service',
    one_eighty: '1-80',
    serti_service: 'Serti - Service',
    serti_rv_service: 'Serti - Service',
    stellantis_digital: 'Stellantis Digital',
    ct_wizard: 'CTWizard',
    ford_direct: 'Ford Canada',
    serti_vente: 'Serti - Sale',
    serti_sale: 'Serti - Sale',
    pbs: 'PBS',
    pbsWorkOrder: 'PBS - Service',
    bmw_canada: 'BMW Canada',
    sertiRenewal: 'Serti - Renewal',
    fniPrestige: 'FNI Prestige',
    maseratiDigital: 'Maserati Digital',
    oneEightyInventory: 'One-Eighty - Inventory',
    cdkInventory: 'CDK - Inventory',
    sertiInventory: 'Serti - Inventory',
    pbsInventory: 'PBS - Inventory',
    easydealInventory: 'EasyDeal - Inventory',
    mitsubishi: 'Mitsubishi',
    hyundai: 'Hyundai',
    deskitInventory: 'Deskit - Inventory',
    deskit_inventory: 'Deskit - Inventory',
    oneSourceInventory: 'One Source - Inventory',
    onesourceInventory: 'One Source - Inventory',
    one_source_inventory: 'One Source - Inventory',
    ncar: 'NCAR',

    hondaCanada: 'Honda Canada',
    acuraCanada: 'Acura Canada',
    honda_canada: 'Honda Canada',
    acura_canada: 'Acura Canada',

    canadianBlackBook: 'Canadian Black Book',

    autovance: 'AutoVance',

    export: {
        autovance: 'AutoVance',
        deskit: 'Deskit',
        lucy: 'Lucy',
        oneEighty: 'One-Eighty',
        sertiVente: 'Merlin',
        merlin: 'Merlin',
        autopropulsion: 'Autopropulsion',
        quicktrade: 'Torque',
        vauto: 'vAuto',
        pbs: 'PBS',
        fniPrestige: 'FNI Prestige',
    },

    tooltip: {
        doublesubmit: 'You can only submit the vehicle once',
        mandatory: 'You need to provide the make, model, year and VIN of the vehicle before submitting',
        mandatoryOnlyVin: 'You need to provide the VIN of the vehicle before submitting',
        mandatoryWithOdometer: 'You need to provide the make, model, year, odometer and VIN of the vehicle before submitting',
        received: 'Evaluation done by {0} on {1}',
        valuesCannotBeNegatives: 'Value and profit cannot have negative values.',
        validVin: 'Invalid VIN. A valid VIN is made of 17 characters.',
        pbsLastNameRequired: 'Lead must have a last name.',
        sertiUserRequired: 'Lead must have an associate assigned.',
    },

    label: {
        unsubmitted: 'Not submitted',
        waiting: 'Evaluation submitted on {0}, waiting...',
        received: 'Evaluation received',
    },

};
